// src/front/js/component/ProtectedRoute.jsx

import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Context } from "../store/appContext";

const ProtectedRoute = ({ children, role, roles, redirectTo = "/panel" }) => {
  const { store } = useContext(Context);
  const location = useLocation();

  if (!store.authResolved) {
    return null;
  }

  // 🔒 No autenticado
  if (!store.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (
    store.mustChangePassword === true &&
    location.pathname !== "/change-password"
  ) {
    return <Navigate to="/change-password" replace />;
  }

  const userRole = store.role;
  const deniedRedirect = userRole === "scanner" ? "/pending-part-exits" : redirectTo;
  // 🔒 Si se usa sistema multi-rol (prioridad)
  if (roles) {
    if (!roles.includes(userRole)) {
      return <Navigate to={deniedRedirect} replace />;
    }
  }

  // 🔒 Si se usa rol único (legacy)
  else if (role) {
    if (userRole !== role) {
      return <Navigate to={deniedRedirect} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
